import { render, staticRenderFns } from "./GarageContactForm.vue?vue&type=template&id=3460acc7"
import script from "./GarageContactForm.vue?vue&type=script&lang=js"
export * from "./GarageContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports